export default String.raw`@media screen and (min-width: 768px)and (max-width: 1439px){.refunds-info{max-width:100%}}`